
import template from 'modal/user/email-signup/email-signup.j2';
import { checkForm, shouldActivateParsley } from '../utils/errorHandling';
import {
    sendEmailSignUpData
} from '../actions/userActions';

import { emailSignupSaga } from '../sagas/userSagas';

import { bindOnPopStateEvent } from '../../../core/js/utils/browserUtils';
import { generate } from '../../../core/js/utils/componentUtils';
import { debug } from '../../../core/js/utils/logger';
import { closeModal } from '../../../core/js/utils/modalUtils';
import { mDom, mDomMaintainInputVals } from '../../../core/js/utils/renderUtils';
import { removeHash } from '../../../core/js/utils/routerUtils';

import { handleUtagEvent } from '../../../core/js/actions/initialActions';
import { clearEmailSignUpForm, changeEmailOptinSource } from '../../../core/js/actions/emailSignupActions';

import { fireGATrackingEvent } from '../../../core/js/utils/analyticsUtils';

/**
 * Regular init function for email sign up modals. Runs changeEmailOptinSource on firstRender if optInSource was provided as an override.
 * optInSource must be a string path to optInSource in our store.
 *
 * @export
 * @param {*} store
 * @param {*} [overrides={}] - optInSource = 'path.to.optInSource.in.core.featureConfigs'
 * @returns Value of generate() return.
 */

export function init(store, overrides = {}) {

    const config = {
        attachEvents: attachEvents,
        firstRender: firstRender,
        watch: ['core.modal.emailSignup'],
        template: template,
        name: 'modal.emailSignup',
        replace: 'once',
        afterCloseAction: afterCloseAction,
        renderType: mDom,
        setOptInSourceIfProvided: setOptInSourceIfProvided,
        renderOptions: mDomMaintainInputVals,
        originatedFromOutsideAccount: false,
        storeRoot: overrides.storeLocation || 'modal',
    };

    // Conditionally update the overrides if optInSource is provided else just pass overrides.
    return generate(config, store, overrides);
}

/**
 * Bootstrap the component onto the page
 * @param {Object} store Redux store
 * @returns {undefined}
 */

function firstRender(store) {
    this.render(store, this);
    if (shouldActivateParsley('.js-email-signup-form')) {
        attachParsley(this, store);
    }

    this.setOptInSourceIfProvided(store);
    addEmailSignupPageViewTracking(store);
}

/**
 * Set optInSource if given.
 *
 * @param {*} store
 */
function setOptInSourceIfProvided(store) {
    if (this.optInSource) {
        store.dispatch(changeEmailOptinSource(this.storeRoot, this.optInSource ? this.optInSource : ''));
    }
}

function afterCloseAction(store) {
    store.dispatch(clearEmailSignUpForm(this));
    fireGATrackingEvent(store, 'email signup close', 'signup close');
    // Remove hash and push state on close
    removeHash();
}

/**
 * Attach component events to DOM
 * @param {Object} store Redux store
 * @returns {undefined}
 */
function attachEvents(store) {
    $(document).on(this.scopedEvent('submit'), this.scopedSelector('.js-email-signup-form'), (e) => {
        debug('#email-signup-form submit');
        e.preventDefault();
        this.attachLoader(store);
        const brandsSelected = Array.from($(this.scopedSelector('[name="additional-brand-signup"]:checked')))
                                    .map((brand) => brand.value);
        const formData = {
            emailAddress: $(this.scopedSelector('[name="email"]')).val(),
            source: store.getState().core.modal.emailSignup.optInSource,
            // Conditionally add extraRequestData
            ...( brandsSelected.length > 0 ? {
                extraRequestData: {
                    additionalBrands: brandsSelected
                }} : {}
            )
        };
        store.runSaga(emailSignupSaga, formData, e, this).done.then(() => {
            const brandsLabel = brandsSelected.join(' | ');
            const eventLabel = brandsSelected.length > 0 ? `signup complete | ${brandsLabel}` : 'signup complete';

            fireGATrackingEvent(store, 'email signup', eventLabel);
            this.removeLoader(store);
        });
    });

    // Close modal on back-button
    bindOnPopStateEvent(this, (e) => {
        closeModal(this, e);
    });
}

function addEmailSignupPageViewTracking(store) {
    const emailSignupUtagData = {
        'page_id': `${store.getState().core.localizations.containers.analyticsContainer.email_signup_page_id}`,
        'category_id': `${store.getState().core.localizations.containers.analyticsContainer.help_category_id}`,
    };
    store.dispatch(handleUtagEvent(emailSignupUtagData, 'view'));
}

function attachParsley(component, store) {
    debug('modal: attachParsleyForEmailSignUp');

    $(component.scopedSelector('.js-email-signup-form')).parsley()
        .on('field:validated', (e) => {
            const [values, msgs] = checkForm(component.scopedSelector('.js-email-signup-form'));
            let previousMsgs = {};
            if (store.getState().core.modal.emailSignup) {
                previousMsgs = store.getState().core.modal.emailSignup.messages;
            }

            store.dispatch(sendEmailSignUpData(_.omitBy(values, _.isEmpty), msgs, previousMsgs));
        });
}
